package org.chiangmeng.qfast

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import org.chiangmeng.qfast.core.di.appModule
import org.koin.core.context.startKoin

private var isKoinInitialized = false

fun initKoin() {
    if (getPlatform().name.contains("Android", ignoreCase = true)) {
        return
    }
    if (!isKoinInitialized) {
        if (getPlatform().name.contains("iOS", ignoreCase = true)) {
            println(">>> [STEP 1] Running on iOS: Firebase initialized via GoogleService-Info.plist")
        } else {
            println(">>> [STEP 1] Starting Firebase.initialize()...")
            try {
                Firebase.initialize(
                    options = FirebaseOptions(
                        apiKey = "AIzaSyD82YtqQr-sH97_IwECbJt-VkuOpV0NWpg",
                        authDomain = "qfast-df5e6.firebaseapp.com",
                        databaseUrl = "https://qfast-df5e6-default-rtdb.asia-southeast1.firebasedatabase.app",
                        projectId = "qfast-df5e6",
                        storageBucket = "qfast-df5e6.firebasestorage.app",
                        gcmSenderId = "1002051622448",
                        applicationId = "1:1002051622448:web:e64c613efd3dbd7fbfbff5"
                    )
                )
                println(">>> [STEP 2] Firebase.initialize() SUCCESS!")
            } catch (e: Throwable) {
                println(">>> [STEP 2 FAILED] Firebase.initialize() CRASHED with: ${e.message}")
                e.printStackTrace()
            }
        }

        println(">>> [STEP 3] Starting Koin...")
        try {
            startKoin {
                modules(appModule)
            }
            println(">>> [STEP 4] Koin started successfully!")
            isKoinInitialized = true
        } catch (e: Throwable) {
            println(">>> [STEP 4 FAILED] Koin start failed: ${e.message}")
            isKoinInitialized = true
        }
    }
}